import AccessTokenApi from './access-token-api.service';
import DataValueApi from './data-value-api.service';
import DischargeModelApi from './discharge-model-api.service';
import OrganizationApi from './organization-api.service';
import StationApi from './station-api.service';
import MeteostationApi from './meteostation-api.service';
import UserApi from './user-api.service';
import CurveSettingsApi from './curve-settings-api.service';
import RequestAccessApi from './request-access-api.service';

import ContactEmailApi from './contact-email-api.service';
import CmsApi from './cms-api.service';

declare var BACKEND_URL:string; // Provided by webpack's DefinePlugin.

export default angular.module('imomo.api', [])
    .constant('backendUrl', BACKEND_URL)
    .service('organizationApi', OrganizationApi)
    .service('userApi', UserApi)
    .service('stationApi', StationApi)
    .service('meteostationApi', MeteostationApi)
    .service('accessTokenApi', AccessTokenApi)
    .service('dischargeModelApi', DischargeModelApi)
    .service('dataValueApi', DataValueApi)
    .service('curveSettingsApi', CurveSettingsApi)
    .service('contactEmailApi', ContactEmailApi)
    .service('requestAccessApi', RequestAccessApi)
    .service('cmsApi', CmsApi)
    .name;



/** WEBPACK FOOTER **
 ** ./app/api/api.module.ts
 **/